import type { DealStage } from '../../api/types';

/** Pipeline order mirrors the backend `deal_stage` enum. */
export const DEAL_STAGES: DealStage[] = [
  'pitched',
  'offer_made',
  'negotiation',
  'pending_signature',
  'signed',
  'lost',
];

export const STAGE_LABELS: Record<DealStage, string> = {
  pitched: 'Pitched',
  offer_made: 'Offer Made',
  negotiation: 'Negotiation',
  pending_signature: 'Pending Signature',
  signed: 'Signed',
  lost: 'Lost',
};

export function stageTone(stage: DealStage): 'primary' | 'neutral' | 'teal' {
  if (stage === 'signed') {
    return 'teal';
  }

  return stage === 'lost' ? 'primary' : 'neutral';
}
